import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { handleErrorResponse } from '../../utils/handleError';
import queryClient from '../../lib/queryClient';
import { updateMedicationReminder } from '../../apis/medicationReminder';

const useUpdateMedicationReminder = () => {
  const { mutate, error, isPending, status, isError, isSuccess } = useMutation({
    mutationKey: ['medication-reminder'],
    mutationFn: ({ id, taken_on }: { id: number; taken_on: string }) =>
      updateMedicationReminder(id, taken_on),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['medication-reminder-list'],
      });
      queryClient.invalidateQueries({
        queryKey: ['medication-consistency'],
      });
    },
    onError: (error: AxiosError) => {
      handleErrorResponse(error, 'Something went wrong');
    },
  });
  return {
    mutate,
    isError,
    isSuccess,
    error,
    isPending,
    status,
  };
};

export default useUpdateMedicationReminder;
